import { ValuesPerEnvironment, Environment, extractConfigValuesBasedOnEnvironment } from './configEnvironment';

export interface Config {
  environment: Environment;
}

const config: ValuesPerEnvironment<Config> = {
  environment: {
    dev: 'dev',
    stage: 'stage',
    prod: 'prod'
  }
};

let builtConfig: Config;
export function getConfig(): Config {
  if (!builtConfig) {
    builtConfig = extractConfigValuesBasedOnEnvironment(config);
  }

  return builtConfig;
}
